import css from 'styled-jsx/css';
import { colors, dimensions } from '../common/Theme';

const styles = css`
  .mentionslegales {
    box-sizing: border-box;
    padding: 24px;
    color: ${colors.ywgNavy};
    background-color: ${colors.ywgPaleGreyTwo};
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-self: center;
    max-width: ${dimensions.ywgSectionMaxWidth};
    color: ${colors.ywgSecondary};
  }
  .mentionslegales__details {
    list-style: none;
    padding-inline-start: 24px;
  }
`;
const MentionsLegales = () => (
  <section className="mentionslegales">
    <h1>Editeur du site</h1>
    <p>
      Le site <a href="https://www.yupwego.com">www.yupwego.com</a> est édité
      par:
    </p>
    <ul className="mentionslegales__details">
      <li>Dénomination sociale: YUPWEGO</li>
      <li>Forme juridique: SAS</li>
      <li>
        Adresse du siège social : 7, chemin des grillons, 69300 Caluire et
        Cuire, France
      </li>
      <li>RCS Lyon n° 842336349</li>
      <li>Capital social: 49 600,00€</li>
      <li>Intermédiaire immatriculé à l´ORIAS sous le N° 19001541</li>
      <li>Numéro individuel d&apos;identification fiscale : FR76 842336349</li>
      <li>Téléphone : 09 72 16 03 55</li>
      <li>Directeur général : Pierre BOURRET</li>
      <li>Directeur de publication du site : Gilles SAUBIN</li>
    </ul>
    <h1>Hébergeur</h1>
    <ul className="mentionslegales__details">
      <li>Dénomination sociale: Zeit, Inc.</li>
      <li>Forme juridique: CORPORATION (Inc.)</li>
      <li>
        Adresse du siège social : 1 Grand Canal Street Lower, Grand Canal Dock,
        Dublin, Ireland
      </li>
      <li>Code of business: C3840731</li>
      <li>
        Site web : <a href="https://zeit.co">https://zeit.co</a>
      </li>
      <li>
        Contact: <a href="mailto:privacy@zeit.co">privacy@zeit.co</a>
      </li>
      <li>
        Politique de confidentialité:{' '}
        <a href="https://zeit.co/privacy">https://zeit.co/privacy</a>
      </li>
    </ul>
    <h1>Processeur de paiement</h1>
    <ul className="mentionslegales__details">
      <li>Dénomination sociale: Stripe Payments Europe, Ltd.</li>
      <li>Forme juridique: Limited Company (LTD)</li>
      <li>
        Adresse du siège social : Stripe 510 Townsend Street San Francisco, CA
        94103, USA, Attention: Stripe Legal
      </li>
      <li>Company number: 513174</li>
      <li>
        Site web : <a href="https://stripe.com">https://stripe.com</a>
      </li>
      <li>
        Contact:{' '}
        <a href="https://stripe.com/fr/contact">
          https://stripe.com/fr/contact
        </a>
      </li>
      <li>
        Politique de confidentialité:{' '}
        <a href="https://stripe.com/fr/privacy">
          https://stripe.com/fr/privacy
        </a>
      </li>
    </ul>
    <style jsx>{styles}</style>
  </section>
);

export default MentionsLegales;
